// ─────────────────────────────────────────────────────────────────────────────
// WARNING — READ BEFORE TOUCHING THIS FILE
//
// This key is NOT a secret and CANNOT be one — it ships inside the browser bundle,
// so anyone who opens dev tools or downloads the deployed JS can read it in seconds.
// It exists ONLY to keep public/env.js's non-sensitive runtime config (the API base
// URL, company id, etc.) out of plaintext at rest, satisfying an audit requirement
// for "no plaintext config in a deployed file." It provides ZERO real confidentiality.
//
// This project decodes env.js SYNCHRONOUSLY (plain XOR + base64, not Web Crypto's
// async AES-GCM) on purpose — src/i18n/config.js and other modules read env.X at
// module top level and fire requests immediately on import, before any async
// decrypt could ever resolve. Keep it synchronous or those eager reads break.
//
// NEVER put an actual secret behind this — no API key, no password, no token, no
// webhook secret. If it's genuinely sensitive, it belongs on the backend, not here.
// (REACT_APP_SECRET_KEY is a separate, pre-existing issue: it's a CRA build-time env
// var baked directly into the JS bundle by webpack — already exposed regardless of
// this file, and out of scope for this env.js change.)
//
// EXCEPTION (2026-10-07): REACT_APP_RPC_USERNAME/REACT_APP_RPC_PASSWORD are a
// DELIBERATE, EXPLICIT EXCEPTION to that rule — a real static service-account login
// ("b2b_generic_user", posted directly to `${REACT_APP_RPC_URL}/rpc/login` in
// src/context/index.js) used to be hardcoded as a literal string directly in source
// (committed to git, baked into every bundle). Moving it here does NOT make it
// secure — this file's own warning above still applies in full, anyone with dev
// tools open can decode it — it only gets the literal value out of source/git going
// forward and matches this project's shared precedent (see Neurosoft's rpcService.js
// RPC credentials, and bakalaros-group/eza's identical fix the same day). The real
// fix is still pending: proxy this login through a real backend endpoint so the
// frontend never holds this credential at all, and rotate the password once that
// exists.
// ─────────────────────────────────────────────────────────────────────────────
export const NON_SECRET_OBFUSCATION_KEY_B64 = '90gNlT4JpLNEm3Z0fte8Z7HkyFVAPgCi1HCIOjJQxow='
